import type { RequiredServices as IRequiredServices } from '@p2l/config';

export const REQUIRED_SERVICES: IRequiredServices = {
  api: [],
  ui: []
};
